import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MobileMajorCat",
  props: {
    majorData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      currentPage: 0,
      touchStartX: 0
    };
  },
  computed: {
    flatMajorData: function flatMajorData() {
      var result = [];
      (this.majorData || []).forEach(function (group) {
        (group || []).forEach(function (item) {
          result.push(item);
        });
      });
      return result;
    },
    pagedData: function pagedData() {
      var result = [];
      var perPage = 8;
      for (var i = 0; i < this.flatMajorData.length; i += perPage) {
        result.push(this.flatMajorData.slice(i, i + perPage));
      }
      return result;
    },
    pageCount: function pageCount() {
      return this.pagedData.length;
    },
    cssVars: function cssVars() {
      return {
        "--mmc-spacing": "16px",
        "--mmc-radius": "12px",
        "--mmc-font-sm": "12px",
        "--mmc-title-color": "#133583",
        "--mmc-desc-color": "#90A1C7",
        "--mmc-primary-light": "#e8f0fe",
        "--mmc-shadow": "0 2px 12px 0 rgba(10, 61, 145, 0.08)",
        "--mmc-padding-top": "20px",
        "--mmc-section-title-font-size": "18px",
        "--mmc-section-title-mb": "12px",
        "--mmc-grid-gap": "12px",
        "--mmc-grid-padding-y": "16px",
        "--mmc-grid-padding-x": "10px",
        "--mmc-item-gap": "6px",
        "--mmc-icon-wrap-size": "48px",
        "--mmc-icon-size": "26px",
        "--mmc-name-min-height": "30px",
        "--mmc-dot-size": "6px",
        "--mmc-dot-gap": "6px"
      };
    }
  },
  methods: {
    getIcon: function getIcon(tindex) {
      var idx = tindex != null ? tindex : 0;
      try {
        return require("@/assets/newimg/four_tool/icons_".concat(idx, ".png"));
      } catch (e) {
        return "";
      }
    },
    handleClick: function handleClick(item) {
      this.$router.push({
        path: "/virtual",
        query: {
          courseType: "14",
          majorName: item.majorName || item.name
        }
      });
    },
    onTouchStart: function onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
    },
    onTouchEnd: function onTouchEnd(e) {
      var dx = e.changedTouches[0].clientX - this.touchStartX;
      if (Math.abs(dx) < 40) return;
      if (dx < 0 && this.currentPage < this.pageCount - 1) {
        this.currentPage++;
      } else if (dx > 0 && this.currentPage > 0) {
        this.currentPage--;
      }
    }
  }
};